import { Injectable } from '@angular/core';
import { NotificacionserviceService } from './notificacionservice.service';
import { KeycloakService } from 'keycloak-angular';
import { semester } from '../novedades/modal-devoluciones/assets/date';
import { mensajeCertificadoDev } from '../novedades/assets/dataMensaje';
import { mensajeCertificado } from '../reporte/assets/dataMensaje';
import { obtenerNombrePeriodo } from '../shared/utils/date';

@Injectable({
    providedIn: 'root',
})
export class EnviarCorreoService {
    datosEmpresa: any;
    private readonly logoHeaderUrl =
        'https://stgprdsiriiagroeastus02.blob.core.windows.net/siriiagro/banner.jpg';
    private readonly emailHeaderHtml = `
    <header>
        <div  style="width: 100%;">
            <img src="${this.logoHeaderUrl}" alt="Logo Siriiagro" style="width: 100%;"/>
        </div>
    </header>
  `;

    constructor(
        private readonly correoService: NotificacionserviceService,
        private readonly keycloakService: KeycloakService
    ) {}

    /**
     * Envía correo de notificación para reportes
     * @param empresa Datos de empresa con periodo (número) que se convierte a nombre de mes
     */
    async enviarCorreo(empresa) {
        return this.procesarEnvioCorreo({
            empresa,
            periodo: obtenerNombrePeriodo(empresa?.periodo),
            tipo: 'reporte',
        });
    }

    async enviarCorreoNovedad(empresa) {
        return this.procesarEnvioCorreo({
            empresa,
            periodo: semester.find((s) => s.name === empresa.semestre).name,
            tipo: 'novedad',
        });
    }

    private async procesarEnvioCorreo({
        empresa,
        periodo,
        tipo,
    }: {
        empresa: any;
        periodo: string;
        tipo: 'reporte' | 'novedad';
    }) {
        try {
            const perfilUsuario = await this.keycloakService.loadUserProfile();
            const userEnvio = {
                nombre:
                    this.capitalizeFirstLetter(perfilUsuario.firstName) +
                    ' ' +
                    this.capitalizeFirstLetter(perfilUsuario.lastName),
                usuarioId: perfilUsuario.id,
            };

            this.datosEmpresa = await this.correoService
                .getEmpresaByNit()
                .toPromise();

            const certificadoData = this.generarCertificado({
                tipo,
                anio: empresa.anio,
                periodo,
                razonSocial: this.datosEmpresa.razonSocial,
                nit: this.datosEmpresa.nit,
            });

            const fechaActual = new Date();
            const formatoFecha = `${fechaActual.getDate()}/${fechaActual.getMonth() + 1}/${fechaActual.getFullYear()}`;

            const correoData = {
                asunto:
                    tipo === 'reporte'
                        ? 'Constancia de reporte'
                        : 'Constancia de novedad',
                mensaje: this.generarMensajeCorreo(
                    userEnvio.nombre,
                    tipo,
                    periodo,
                    empresa.anio,
                    this.datosEmpresa,
                    formatoFecha
                ),
                msgCertificado: certificadoData,
                correoCorporativo: this.datosEmpresa.correo_corporativo,
            };

            const response = await this.correoService
                .postEmailService(correoData)
                .toPromise();
            console.log('Correo enviado con éxito', response);
        } catch (error) {
            throw error;
        }
    }

    private generarCertificado({
        tipo,
        anio,
        periodo,
        razonSocial,
        nit,
    }: {
        tipo: 'reporte' | 'novedad';
        anio: number;
        periodo: string;
        razonSocial: string;
        nit: string;
    }) {
        return tipo === 'reporte'
            ? mensajeCertificado({ anio, mes: periodo, razonSocial, nit })
            : mensajeCertificadoDev({
                  anio,
                  semestre: periodo,
                  razonSocial,
                  nit,
              });
    }

    private generarMensajeCorreo(
        nombre: string,
        tipo: 'reporte' | 'novedad',
        periodo: string,
        anio: number,
        empresa: any,
        fecha: string
    ) {
        const tipoTexto = tipo === 'reporte' ? 'el reporte' : 'la novedad';

        return `<div style="font-size: 1.4rem;">NOTIFICACIÓN Sirii<strong>agro</strong></div><br>
      ${this.emailHeaderHtml}
      <p>Cordial saludo, ${nombre}.</p>
      <p>Se notifica que ${tipoTexto} correspondiente a ${periodo} de ${anio} para la empresa ${empresa.razonSocial} con NIT ${empresa.nit} se ha registrado exitosamente el día ${fecha}.</p>
      <p>Gracias por su colaboración y por su confianza en nuestros servicios. Para gestionar cualquier inquietud adicional, contáctese al correo gestionsiriiagro@upra.gov.co.</p>
      <p>Cordialmente,</p>
      <p>Unidad de Planificación Rural Agropecuaria (UPRA)</p>
      <p>Aviso legal: En atención a lo dispuesto por la Ley 1581 de 2012 y normas reglamentarias, se informa que se garantizará la confidencialidad, la privacidad, la seguridad y la circulación restringida de los datos que sean de índole personal de los aquí recolectados; se utilizarán exclusivamente para las finalidades mencionadas.</p>`;
    }

    private capitalizeFirstLetter(str: string): string {
        if (!str) return str;
        return str
            .toLocaleLowerCase()
            .replace(
                /(^|\s)(\p{L})/gu,
                (_, sep, letra) => sep + letra.toLocaleUpperCase()
            );
    }
}
